<template>
    <div>
      <!--添加通知信息-->
      <div class="logindiv" id="AddForm_a_type">
        <div class="loginForm">
          <div style="width: 100%;height: 40px;background-color: #2d2d2d;margin: 0 auto;">
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
              添加系统权限信息
            </span>
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
              <a href="javascript:;" @click="close">
                <i class="el-icon-close"></i>
              </a>
            </span>
          </div>
          <div style="width: 300px;margin: 0 auto;">
            <el-form :model="AddForm" :rules="rules" ref="AddForm" style="margin-top: 50px;">
              <el-form-item prop="type_name">
                <el-input type="text" v-model="AddForm.type_name" placeholder="权限名称"></el-input>
              </el-form-item>
              <el-form-item prop="type">
                <el-input type="text" v-model="AddForm.type" placeholder="权限等级"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="loading" style="width: 300px;" v-if="AddForm.tp==0" @click="AddLabel">提交</el-button>
                <el-button type="primary" :loading="loading" style="width: 300px;" v-else-if="AddForm.tp==1" @click="UpdateLabel">保存</el-button>
              </el-form-item>
            </el-form>
          </div>
          <br>
        </div>
      </div>
      <div>
        <el-container>
          <el-header style="background-color:white;margin-top: 5px;height: 40px;">
            <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
              <el-form-item>
                <el-button type="primary" class="btn" @click="Addwindow()"><i class="el-icon-circle-plus-outline"></i>添加新权限</el-button>
              </el-form-item>
              <el-form-item label="权限名称">
                <el-input v-model="formInline.type_name" placeholder="权限名称" class="elInput"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="btn" @click="getData()"><i class="el-icon-search"></i>查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="danger" class="btn" @click="resetting()"><i class="el-icon-refresh"></i>重置</el-button>
              </el-form-item>
            </el-form>
          </el-header>
          <el-main class="elMain">
            <el-table v-loading="loading" :data="tableData" height="100%" stripe border size="medium ">
              <el-table-column align="center" label="ID" prop="id" width="300"></el-table-column>
              <el-table-column align="center" label="权限名称" prop="type_name"></el-table-column>
              <el-table-column align="center" label="权限等级" prop="type" width="300"></el-table-column>
              <el-table-column fixed="right" label="操作" width="300">
                <template slot-scope="scope">
                  <span>
                    <el-button size="small" @click="Updatewindow(scope.row)">修改</el-button>
                  </span>
                  <!--
                  <span>
                    <el-popconfirm
                      confirmButtonText='好的'
                      cancelButtonText='不用了'
                      icon="el-icon-info"
                      iconColor="red"
                      title="这是一段内容确定删除吗？"
                      @onConfirm="deletes(scope.$index, scope.row)"
                    >
                      <el-button size="small" slot="reference">删除</el-button>
                    </el-popconfirm>
                  </span>
                  -->
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer>
            <div style="padding: 15px 0;text-align: right;">
              <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.pageNum"
                :page-sizes="pageSizes" :page-size="formInline.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
              </el-pagination>
            </div>
          </el-footer>
        </el-container>
      </div>
    </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  export default {
    data() {
      var type_name = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error('请输入权限名称'))
        } else {
          callback()
        }
      }
      var type = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error('请输入权限等级'))
        } else {
          callback()
        }
      }
      return {
        data:'',
        tableData: [],
        loading: false,
        formInline: {
          type_name:'',
          pageNum:1,
          pageSize:10
        },
        pageSizes:[5, 10, 15, 20],
        pageTotal:0,
        AddForm:{
          type_name:'',
          type:'',
          tp:0,
        },
        rules: {
          type_name: [{
            required: true,
            trigger: 'blur',
            validator: type_name
          }],
          type: [{
            required: true,
            trigger: 'blur',
            validator: type
          }]
        },
      }
    },
    //页面开启时执行
    mounted(){
      this.chark();
      this.getData();
    },
    methods: {
      //进行判定
      chark(){
        this.$emit("parentHandle", 1)
      },
      //重置查询
      resetting() {
        this.formInline.type_name = '';
        this.getData();
      },
      //添加内容
      AddLabel(){
        this.$refs.AddForm.validate(valid => {
        if (valid) {
          this.AddForm.admin_id=this.$store.state.a_id;
          commonAPI('AddAdmin_type',this.AddForm).then(res => {
            let data = res.data;
            //console.log(res.data.rows);
            if(this.response.response(data)){
              this.AddForm.type_name='';
              this.AddForm.type='';
              this.getData();
              this.close();
            }
          }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
        }else{
          return false;
        }
        })
      },
      //修改内容
      UpdateLabel(){
        this.$refs.AddForm.validate(valid => {
        if (valid) {
          this.AddForm.admin_id=this.$store.state.a_id;
          commonAPI('updateAdmin_type',this.AddForm).then(res => {
            let data = res.data;
            //console.log(res.data.rows);
            if(this.response.response(data)){
              this.AddForm.type_name='';
              this.AddForm.type='';
              this.getData();
              this.close();
            }
          }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
        }else{
          return false;
        }
        })
      },
      //打开窗口
      Updatewindow(row){
        this.AddForm.type_name=row.type_name;
        this.AddForm.type=row.type;
        this.AddForm.tp=1;
        this.AddForm.id=row.id;
        document.getElementById('AddForm_a_type').style.display='block';
        document.getElementById('zhedang').style.display='block';
      },
      Addwindow(row){
        //this.AddForm.message_id=row.id;
        this.AddForm.tp=0;
        document.getElementById('AddForm_a_type').style.display='block';
        document.getElementById('zhedang').style.display='block';
        //console.log('打开窗口');
      },
      //删除
      deletes(index, row) {
        let admin_id=this.$store.state.a_id;
        row.admin_id=admin_id;
        //console.log(index, row);
        commonAPI('deleteAdmin_type',row).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
          }
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
      },
      //查询
      getData() {
        this.loading = true,
          commonAPI('queryAdmin_type',this.formInline).then(res => {
            this.loading = false;
            this.tableData = res.data.data.rows;
            this.pageTotal=res.data.data.total;
            //console.log(res.data.rows);
          })
      },
      onSubmit() {
        this.getData();
      },
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.formInline.pageSize=val;
        this.formInline.pageNum=1;
        this.getData();
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.formInline.pageNum=val;
        this.getData();
      },
      close(){
        this.AddForm.title='';
        this.AddForm.content='';
        this.AddForm.tp=0;
        document.getElementById('AddForm_a_type').style.display='none';
        document.getElementById('zhedang').style.display='none';
      },
    }
  }
</script>

<style scoped>
  .elInput,
  .btn {
    margin-top: 0px;
  }
  .el-main {
    padding: 5px 10px;
  }
  .elMain{
    height: 700px;
  }
  .el-table th {
    height: 45px;
    font-size: 16px;
    font-family: 微软雅黑;
    font-weight: 500;
    color: darkblue;
  }
  /**登录框架*/
  .logindiv{
    position: fixed;
    top: 25%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    text-align: center;
    display: none;
  }
  .loginForm{
    margin: 0 auto;
    width: 550px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .loginForm a{
    color: #fff;
  }
  .loginForm a:hover{
    color: #d6d6d6;
  }

  /**Orderinfor框架*/
  .Orderinfordiv{
    position: fixed;
    top: 13%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    display: none;
  }
  .OrderinforForm{
    margin: 0 auto;
    width: 900px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .OrderinforForm a{
    color: #fff;
  }
  .OrderinforForm a:hover{
    color: #d6d6d6;
  }
  .playlistbox_botton{
     width: 900px;margin: 0 auto;
     overflow: hidden;
     height: 633px;
     overflow-y: scroll;
   }
   /**滚动条样式*/
   .playlistbox_botton::-webkit-scrollbar{
     width: 5px;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     border-radius: 10px;
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     background: #535353;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     border-radius: 10px;
     background: #EDEDED;
   }
   /**！Orderinfor框架*/
</style>



// WEBPACK FOOTER //
// src/admin/views/systemAdmin/Admin_Type.vue